import { StyleSheet } from 'aphrodite'

const styles = StyleSheet.create({
  dropZone: {
    background: '#f6f8fa',
    overflow: 'hidden',
    flexGrow: 1,
    order: 0
  },
  innerDropZone: {
    boxSizing: 'border-box',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: 4
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Media/FileDropZone/styles.js